import { render } from "./ScreeningsView.vue?vue&type=template&id=7ea1923a"
const script = {}

import "./ScreeningsView.vue?vue&type=style&index=0&id=7ea1923a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__